export default __webpack_public_path__ + "static/profnastil-647e14037775ffc7e1ffee49630a3ca5.jpg";